/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Learn_C3_TitleInputs */

const en_cad_learn_c3_title = /** @type {(inputs: Cad_Learn_C3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automate with agents`)
};

/**
* | output |
* | --- |
* | "Automate with agents" |
*
* @param {Cad_Learn_C3_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_learn_c3_title = /** @type {((inputs?: Cad_Learn_C3_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Learn_C3_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_learn_c3_title(inputs)
});
export { cad_learn_c3_title as "cad.learn.c3_title" }